/**
 * Parse an indexed shapeId of the form `"prefix:N"` and return the numeric
 * index, or `null` when the string doesn't match the expected pattern.
 */
function indexFromShapeId(prefix: string, shapeId: string): number | null {
  const match = new RegExp(`^${prefix}:(\\d+)$`).exec(shapeId);
  if (!match) {
    return null;
  }
  const idx = Number.parseInt(match[1], 10);
  return Number.isNaN(idx) ? null : idx;
}

/** Extract the perimeter index from `"outline:N"`, or `null`. */
export function floorPerimeterIndexFromShapeId(shapeId: string): number | null {
  return indexFromShapeId("outline", shapeId);
}

/** Extract the opening index from `"opening:N"`, or `null`. */
export function floorOpeningIndexFromShapeId(shapeId: string): number | null {
  return indexFromShapeId("opening", shapeId);
}
